import Vue from 'vue'
import Router from 'vue-router'
import Products from '@/views/Products.vue'
import Marketing from '@/views/Marketing.vue'
import Orders from '@/views/Orders.vue'
import Login from '@/views/Login.vue'
import Banner from '@/views/Banner.vue'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    { path: '/', redirect: '/login' },
    { path: '/login', component: Login },
    { path: '/products', component: Products, meta: { requiresAuth: true } },
    { path: '/marketing', component: Marketing, meta: { requiresAuth: true } },
    { path: '/orders', component: Orders, meta: { requiresAuth: true } },
    { path: '/banner', component: Banner, meta: { requiresAuth: true } }
  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('wxshop_token')
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      next({ path: '/login', query: { redirect: to.fullPath } })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
